import { CCPAContainer } from './CCPA.styles';

const CCPA: React.FC = () => {
  return <CCPAContainer id='pm_ccpa_container' />;
};

export default CCPA;
